import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/success.png'
import _imports_1 from '@/assets/images/error.png'


const _hoisted_1 = { class: "min-h-full flex flex-col justify-center py-2" }
const _hoisted_2 = { class: "w-full relative flex flex-col justify-center items-center" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-0 left-15 bg-gray-50 opacity-80 flex flex-col justify-center items-center",
  style: {"width":"240px","height":"240px"}
}
const _hoisted_4 = {
  key: 1,
  style: {"width":"240px","height":"240px"},
  class: "absolute z-10 top-0 left-15 flex flex-col justify-center items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-8"
}, null, -1)
const _hoisted_6 = { class: "avatar online mt-4" }
const _hoisted_7 = { class: "rounded-btn w-16 h-16" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = {
  key: 2,
  style: {"width":"240px","height":"240px"},
  class: "absolute z-10 top-0 left-15 flex flex-col justify-center items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-12 h-12"
}, null, -1)
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRCodeVue3 = _resolveComponent("QRCodeVue3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_QRCodeVue3, {
        width: 240,
        height: 240,
        value: _ctx.qrUrl,
        qrOptions: {
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'H',
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0,
        },
        dotsOptions: {
          type: 'dots',
          color: '#638CC7',
          gradient: {
            type: 'linear',
            rotation: 0,
            colorStops: [
              { offset: 0, color: '#638CC7' },
              { offset: 1, color: '#638CC7' },
            ],
          },
        }
      }, null, 8, ["value", "imageOptions"]),
      (_ctx.currentStudent.avatar || _ctx.intervalMaxCount == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.currentStudent.avatar && _ctx.intervalMaxCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.currentStudent.avatar
                }, null, 8, _hoisted_8)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentStudent.name ? _ctx.currentStudent.name : _ctx.currentStudent.nickname), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.currentStudent.avatar && _ctx.intervalMaxCount == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("button", {
              class: "btn btn-link btn-active btn-wide text-xl mt-4 text-black",
              role: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
              "aria-pressed": "true"
            }, " 刷新 ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.intervalMaxCount > 0 && !_ctx.currentStudent.avatar)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.intervalMaxCount) + ")", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}